@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

.labsConfirmationModal {
  .modal-header {
    background-color: transparent;
    box-shadow: none;
    width: 100%;
    position: relative;
    padding: @space-32 @space-32 @space-16 @space-32;
    border-bottom: 1px solid var(--default--border-color--6);
  }

  .modal-body {
    height: 500px; // Fixed height to ensure footer stays at bottom
    padding: 0;
  }

  .contentWrapper {
    flex: 1;
    background-color: var(--light--background-color--1);
  }

  .scrollableContent {
    flex: 1;
    overflow-y: auto;
    padding: @space-32;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: var(--default--background-color--10);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--default--border-color--15);
      border-radius: 4px;

      &:hover {
        background: var(--default--border-color--20);
      }
    }
  }

  .featureConfirmationText,
  .disableConfirmationText {
    line-height: 1.6;

    ul {
      margin: @space-16 0;
      padding-left: @space-20;

      li {
        margin-bottom: @space-8;
        line-height: 1.5;
      }
    }
  }

  .modalFooter {
    background-color: var(--light--background-color--1);
    border-top: 1px solid var(--default--border-color--6);
    box-shadow: 0 -4px 8px -2px var(--black-fade-5);
    padding: @space-24 @space-32;
    margin-top: auto;
  }

  .loadingContainer {
    margin-bottom: @space-16;
  }

  .footerRow {
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .successMessage {
    color: var(--green-600);
    align-items: center;
  }

  .successIcon {
    height: @space-16;
    width: @space-16;
  }

  .buttonContainer {
    justify-content: flex-end;
    gap: @space-16;
    margin-left: auto;
  }

  .upsell-icon {
    margin-right: @space-8;
    height: @space-16;
    width: @space-16;
  }
}

@media (max-width: 1200px) {
  .labsConfirmationModal {
    .modal-body {
      height: 400px;
    }

    .scrollableContent {
      padding: @space-24;
    }

    .modalFooter {
      padding: @space-16 @space-24;
    }
  }
}

@media (max-width: 768px) {
  .labsConfirmationModal {
    .modal-header {
      padding: @space-16;
    }

    .modal-body {
      height: 300px;
    }

    .scrollableContent {
      padding: @space-16;
    }

    .buttonContainer {
      flex-direction: column;

      button {
        width: 100%;
      }
    }
  }
}
